export const SidebarContent = () => {
  return <></>;
};
